import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

const TableData = ({
  cols,
  height,
  rows = [],
  onRowClick,
  isLoading,
  onCellClick,
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: {
          xs: '89vw',
          sm: 'calc(92vw - 220px)',
          md: 'calc(86vw - 220px)',
          lg: 'calc(90vw - 220px)',
        },
        height: height,
      }}
    >
      <DataGrid
        rows={rows}
        columns={cols}
        onRowClick={onRowClick}
        onCellClick={onCellClick}
        loading={isLoading}
        rowsPerPageOptions={[5, 10, 20]}
        sx={{
          '& .MuiDataGrid-withBorderColor': {
            borderColor: '#03284233',
          },
          '& .MuiDataGrid-columnHeaderTitleContainer': {
            color: 'secondary.main',
            fontSize: 12,
            fontWeight: 300,
          },
          // border: 'none',
          fontSize: 12,
          fontWeight: 300,
          color: 'primary.main',
          boxShadow: '0px 0px 8px 4px #cdcccc4d',
          backdropFilter: 'blur(20px)',
        }}
      />
    </Box>
  );
};
TableData.propTypes = {
  rows: PropTypes.array,
  cols: PropTypes.array,
  height: PropTypes.string,
  width: PropTypes.string,
  onRowClick: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default TableData;
